import * as  moment from 'moment';
import { AppConstants } from 'src/app/common/enum/app.constants';
import { EnumTipoConsultaOptimizado } from 'src/app/common/enum/TipoPersona.enum';
export class Transacciones {
    public Nombre: string;
    public SNombre: string;
    public ApellidoPaterno: string;
    public ApellidoMaterno: string;
    public RFC: string;
    public PersonalidadFiscalId: string;
    public MontoInicial: number;
    public MontoFinal: number;
    public FechaInicial: string;
    public FechaFinal: string;
    public Referencia: string;
    public Pagina: number;
    public UsuarioId: number;
    public ClienteId: number;
    public Perfil: number;
    public EsCredito: number;
    public EsCaptacion: number;
    public Seleccionado: number;
    public PersonalidadFiscal: [];
    public TipoBusqueda: number;
    public ClaveCia: string;
    public Contrato:string;
    public TipoFecha:number;
    public Reportadas: number;
    public IdNotificacion: string;
    public BatchNumber: number;
    public BatchSize : number;
    public TipoConsulta : number;
    public ProductoId:number;

    constructor() {
     const FORMATO_SALIDA = 'YYYY-MM-DD';
        const FORMATO_ENTRADA = 'YYYY-MM-DDTHH:mm:ss Z';
        const fechainicial = moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1), FORMATO_ENTRADA);
        const fechafinal = moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0), FORMATO_ENTRADA);
        this.FechaInicial = fechainicial.format(FORMATO_SALIDA);
        this.FechaFinal = fechafinal.format(FORMATO_SALIDA);
        this.Pagina = 1;
        this.Nombre = '';
        this.SNombre = '';
        this.ApellidoPaterno = '';
        this.ApellidoMaterno = '';
        this.UsuarioId = 0;
        this.ClienteId = 0;
        this.Contrato = '';
        this.TipoBusqueda = 1;
        this.PersonalidadFiscalId = '-1'
        this.ProductoId = -1;
        this.BatchNumber = 1;
        this.BatchSize = (AppConstants.NUM_PAGES * AppConstants.ROWS_PER_PAGE) + 1;
        this.TipoConsulta = EnumTipoConsultaOptimizado.getDataGrid;
        this.Reportadas = 0;
    }
}
